export default __webpack_public_path__ + "static/media/confetti-BR.26677d13.svg";